import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Brands } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Brands.Pages.BRAND}`,
    name: Brands.Pages.BRAND,
    component: () => import(/* webpackChunkName: "brands" */ './views/Brands.vue'),
    meta: {
      access_roles: RouteRoles[Brands.Pages.BRAND],
    },
  },
  {
    path: `/${Brands.Pages.DESIGN}/:id`,
    name: Brands.Pages.DESIGN,
    component: () => import(/* webpackChunkName: "brands" */ './views/Design.vue'),
    meta: {
      access_roles: RouteRoles[Brands.Pages.DESIGN],
    },
  },
];

export default routes;
